import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'xm-modal-close',
    templateUrl: 'close.html',
    styleUrls: ['close.scss'],
    standalone: false
})

export class ModalCloseButton implements OnInit {
    @Output() public onClose: EventEmitter<void> = new EventEmitter<void>();
    @Input() public isActivityModal: boolean;
    @Input() public closeAutoFocus: boolean;

    public imageOptions: MediaImageOptions;

    public ngOnInit(): void {
        this.imageOptions = {
            mobile: {
                base: 'close_24_black.svg',
                version: '1500575503',
                icon: true
            }
        };
    }

    public closeClick(): void {
        this.onClose.emit();
    }
}
